// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.payment.DeleteOneTimePaymentRequestWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { DeleteOneTimePaymentRequestWebApiRequestDto } from '../..';

export const DeleteOneTimePaymentRequestWebApiHandler_deleteOneTimePaymentRequest_Path =
  '/api/web/v1/payment/deleteOneTimePaymentRequest';

/**
 * Delete one time payment request
 */
export const DeleteOneTimePaymentRequestWebApiHandler_deleteOneTimePaymentRequest = (
  postData: DeleteOneTimePaymentRequestWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, DeleteOneTimePaymentRequestWebApiRequestDto, void>(
    {
      endpoint: DeleteOneTimePaymentRequestWebApiHandler_deleteOneTimePaymentRequest_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
